import { create } from 'zustand';
const initialState = {
    matomoTracker: undefined,
};
export const useTrackingStore = create()(set => ({
    ...initialState,
    setMatomoTracker: ({ matomoTracker }) => set({ matomoTracker }),
}));
